<template>
  <v-container>
    <v-row>
      <v-col
        xs="12"
      >
        <v-card>
          <v-btn @click="dialog = true" fab fixed bottom right dark color="indigo">
            <v-icon dark>add</v-icon>
          </v-btn>
          <v-card-title class="headline">Atendentes</v-card-title>
          <v-card-text>
            <List @edit="edit" @remove="remove" :key="list"/>
          </v-card-text>
          <Create            
            :dialog="dialog"
            @closeDialog="closeDialog"  
          />
          <Edit 
            v-if="selectedAttendant" 
            :dialog="editDialog" 
            :selectedAttendant="selectedAttendant" 
            @closeEdit="closeDialog"
            @updateContent="updateContent"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import List from './List';
  import Create from './Create';
  import Edit from './Edit';
  
  export default {
    components: {
      List,
      Create,
      Edit
    },
    name: 'index',
    methods: {
      closeDialog() {
        this.selectedAttendant = null;
        this.dialog = false;
        return;
      },
      edit (data) {
        this.selectedAttendant = data;
        this.editDialog = true;  
        return;    
      },
      remove(data) {
        if (
          confirm('Tem certeza que quer deletar este atendente?')
        ) {
          this.$store.dispatch('deleteAttendant', {params: {id: data}});
          setTimeout(() => this.updateContent(), 500);
			  }
		  },
      updateContent(time = null) {
        if(time) {
          setTimeout(() => this.updateContent(), time);
          return;
        }

        this.list++;
        this.$forceUpdate();
        return;
      }
    },
    data () {
      return {
        list: 0,
        dialog: false,
        editDialog: false,
        selectedAttendant: null
      }
    }
  }
</script>

<style lang="css" scoped>
</style>